// extracted by mini-css-extract-plugin
export var box = "_1d-2";
export var checkboxControl = "_1d-0";
export var checkboxRow = "_1d-a";
export var checked = "_1d-3";
export var descriptionSpacer = "_1d-c";
export var disabled = "_1d-4";
export var icon = "_1d-8";
export var input = "_1d-1";
export var labelSpacer = "_1d-b";
export var large = "_1d-7";
export var medium = "_1d-6";
export var small = "_1d-5";
export var text = "_1d-9";